import { newApi } from "../restdux/index";

export const contractedServiceAPI = newApi(
  "contracted-service",
  "/api/contracted-service/"
);

export const reducer = contractedServiceAPI.reducer;

export function fetchContractedServices(contractId) {
  return contractedServiceAPI.actions.list({ contract: contractId });
}

export function createContractedService(data) {
  return contractedServiceAPI.actions.create(data);
}

export function updateContractedService(data) {
  return contractedServiceAPI.actions.update(data);
}

export function deleteContractedService(data) {
  return contractedServiceAPI.actions.del(data);
}

export const clearServiceError = contractedServiceAPI.actions.clearError;
